import React, { createContext, useEffect, useState } from "react";
import { loadChannelReadReceipts, mergeReadStates } from "./channelReadReceiptLoader";

export const ChannelReadReceiptsContext = createContext({ status: "loading", read: {}, members: {} });

export const ChannelReadReceiptsProvider = ({ channel, children }) => {
  const [state, setState] = useState({ status: "loading", read: {}, members: {} });
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    if (!channel?.id) return;
    let cancelled = false;
    let liveRead = {};
    setState({ channel, status: "loading", read: {}, members: {} });
    const subscription = channel.on("message.read", (event) => {
      if (!event.user?.id || !event.created_at || event.parent_id) return;
      const incoming = { [event.user.id]: {
        user: event.user,
        last_read: event.created_at,
        last_read_message_id: event.last_read_message_id,
      } };
      liveRead = mergeReadStates(liveRead, incoming);
      if (!cancelled) setState((current) => ({ ...current, read: mergeReadStates(current.read, incoming) }));
    });
    const refresh = () => { if (!cancelled) setRevision((value) => value + 1); };
    const recovery = channel.getClient().on("connection.recovered", refresh);
    const added = channel.on("member.added", refresh);
    const removed = channel.on("member.removed", refresh);
    loadChannelReadReceipts(channel, () => cancelled).then((result) => {
      if (!cancelled && result) setState({
        channel, status: "ready", members: result.members,
        read: mergeReadStates(result.read, liveRead),
      });
    }).catch(() => {
      if (!cancelled) setState({ channel, status: "error", read: {}, members: {} });
    });
    return () => {
      cancelled = true;
      [subscription, recovery, added, removed].forEach((listener) => listener.unsubscribe());
    };
  }, [channel, revision]);
  const value = state.channel === channel ? state : { status: "loading", read: {}, members: {} };
  return React.createElement(ChannelReadReceiptsContext.Provider, {
    value: { ...value, retry: () => setRevision((current) => current + 1) },
  }, children);
};
